import {
   CARETAKER,
   COOWNER,
   COOWNER_SECONDARY,
   COOWNERSHIP_BOARD_MEMBER,
   DIRECTOR,
   EMPLOYEE,
   PRESIDENT_BOARD_MEMBER,
   SERGIC_OFFER,
   SERGIC_PARTNER,
   TENANT,
} from '../constants';

// Alpha
export const allowedToAccessForum =
   SERGIC_OFFER === 'NEUF'
      ? []
      : SERGIC_OFFER === 'DIR'
      ? [
           PRESIDENT_BOARD_MEMBER,
           SERGIC_PARTNER,
           DIRECTOR,
           COOWNERSHIP_BOARD_MEMBER,
           COOWNER,
           COOWNER_SECONDARY,
           TENANT,
           CARETAKER,
           EMPLOYEE,
        ]
      : SERGIC_OFFER === 'VQC'
      ? [PRESIDENT_BOARD_MEMBER, COOWNERSHIP_BOARD_MEMBER]
      : [PRESIDENT_BOARD_MEMBER, COOWNERSHIP_BOARD_MEMBER, SERGIC_PARTNER, DIRECTOR];

export const allowedToSendRealEstateProject =
   SERGIC_OFFER === 'VQC' || SERGIC_OFFER === 'DIR'
      ? []
      : [
           PRESIDENT_BOARD_MEMBER,
           SERGIC_PARTNER,
           DIRECTOR,
           COOWNERSHIP_BOARD_MEMBER,
           COOWNER,
           COOWNER_SECONDARY,
           TENANT,
           CARETAKER,
           EMPLOYEE,
        ];

// Alpha
export const allowedToAccessContracts = [
   PRESIDENT_BOARD_MEMBER,
   SERGIC_PARTNER,
   DIRECTOR,
   COOWNERSHIP_BOARD_MEMBER,
   COOWNER,
   COOWNER_SECONDARY,
];

export const allowedToAccessDocuments = [
   PRESIDENT_BOARD_MEMBER,
   SERGIC_PARTNER,
   DIRECTOR,
   COOWNERSHIP_BOARD_MEMBER,
   COOWNER,
   COOWNER_SECONDARY,
];

export const allowedToAccessPublicAccounts =
   SERGIC_OFFER === 'ECO'
      ? []
      : [PRESIDENT_BOARD_MEMBER, SERGIC_PARTNER, DIRECTOR, COOWNERSHIP_BOARD_MEMBER, COOWNER, COOWNER_SECONDARY];

export const allowedToAccessTreasuries = [
   PRESIDENT_BOARD_MEMBER,
   SERGIC_PARTNER,
   DIRECTOR,
   COOWNERSHIP_BOARD_MEMBER,
   COOWNER,
   COOWNER_SECONDARY,
];

export const allowedToAccessBudget = [
   PRESIDENT_BOARD_MEMBER,
   SERGIC_PARTNER,
   DIRECTOR,
   COOWNERSHIP_BOARD_MEMBER,
   COOWNER,
   COOWNER_SECONDARY,
];

export const allowedToAccessWorks = [
   PRESIDENT_BOARD_MEMBER,
   SERGIC_PARTNER,
   DIRECTOR,
   COOWNERSHIP_BOARD_MEMBER,
   COOWNER,
   COOWNER_SECONDARY,
];

export const allowedToAccessExpenses = [
  PRESIDENT_BOARD_MEMBER,
  SERGIC_PARTNER,
  DIRECTOR,
  COOWNERSHIP_BOARD_MEMBER,
  COOWNER,
  COOWNER_SECONDARY,
];

export const allowedToAccessOwnAccounts =
   SERGIC_OFFER === 'NEUF'
      ? []
      : [PRESIDENT_BOARD_MEMBER, SERGIC_PARTNER, DIRECTOR, COOWNERSHIP_BOARD_MEMBER, COOWNER, COOWNER_SECONDARY];

// Beta
export const allowedToAccessConversations =
   SERGIC_OFFER === 'DIR'
      ? [PRESIDENT_BOARD_MEMBER, COOWNERSHIP_BOARD_MEMBER, COOWNER, COOWNER_SECONDARY]
      : [
           PRESIDENT_BOARD_MEMBER,
           SERGIC_PARTNER,
           DIRECTOR,
           COOWNERSHIP_BOARD_MEMBER,
           COOWNER,
           COOWNER_SECONDARY,
           TENANT,
        ];

export const allowedToAccessReports =
   SERGIC_OFFER === 'ECO' || SERGIC_OFFER === 'NEUF'
      ? []
      : [
           PRESIDENT_BOARD_MEMBER,
           SERGIC_PARTNER,
           DIRECTOR,
           COOWNERSHIP_BOARD_MEMBER,
           COOWNER,
           COOWNER_SECONDARY,
           TENANT,
           CARETAKER,
           EMPLOYEE,
        ];

export const allowedToAccessAccounts =
   SERGIC_OFFER === 'NEUF'
      ? []
      : [
           PRESIDENT_BOARD_MEMBER,
           SERGIC_PARTNER,
           DIRECTOR,
           COOWNERSHIP_BOARD_MEMBER,
           COOWNER,
           COOWNER_SECONDARY,
           // TENANT,
        ];

export const allowedToContactSupport = [
   PRESIDENT_BOARD_MEMBER,
   SERGIC_PARTNER,
   DIRECTOR,
   COOWNERSHIP_BOARD_MEMBER,
   COOWNER,
   COOWNER_SECONDARY,
   TENANT,
];

// Gamma
export const allowedToAccessCommunity = [
   PRESIDENT_BOARD_MEMBER,
   SERGIC_PARTNER,
   DIRECTOR,
   COOWNERSHIP_BOARD_MEMBER,
   COOWNER,
   COOWNER_SECONDARY,
   TENANT,
   CARETAKER,
];

export const allowedToAccessContacts = [
   PRESIDENT_BOARD_MEMBER,
   SERGIC_PARTNER,
   DIRECTOR,
   COOWNERSHIP_BOARD_MEMBER,
   COOWNER,
   COOWNER_SECONDARY,
   TENANT,
   CARETAKER,
];

export const allowedToAccessOwnPlaces = [
   PRESIDENT_BOARD_MEMBER,
   SERGIC_PARTNER,
   DIRECTOR,
   COOWNERSHIP_BOARD_MEMBER,
   COOWNER,
   COOWNER_SECONDARY,
   TENANT,
   CARETAKER,
];

// Delta
export const allowedToAccessOwnProfile = [
   PRESIDENT_BOARD_MEMBER,
   SERGIC_PARTNER,
   DIRECTOR,
   COOWNERSHIP_BOARD_MEMBER,
   COOWNER,
   COOWNER_SECONDARY,
   TENANT,
   CARETAKER,
   EMPLOYEE,
];

export const allowedToAccessFeed = [
   PRESIDENT_BOARD_MEMBER,
   SERGIC_PARTNER,
   DIRECTOR,
   COOWNERSHIP_BOARD_MEMBER,
   COOWNER,
   COOWNER_SECONDARY,
   TENANT,
   CARETAKER,
   EMPLOYEE,
];

export const allowedToAccessSupport =
   SERGIC_OFFER === 'DIRR'
      ? [
           PRESIDENT_BOARD_MEMBER,
           SERGIC_PARTNER,
           DIRECTOR,
           COOWNERSHIP_BOARD_MEMBER,
           COOWNER,
           COOWNER_SECONDARY,
           TENANT,
           CARETAKER,
           EMPLOYEE,
        ]
      : [];

export const allowedToEditProfile =
   SERGIC_OFFER !== 'VQC'
      ? [
           PRESIDENT_BOARD_MEMBER,
           SERGIC_PARTNER,
           DIRECTOR,
           COOWNERSHIP_BOARD_MEMBER,
           COOWNER,
           COOWNER_SECONDARY,
           TENANT,
           CARETAKER,
           EMPLOYEE,
        ]
      : [];

export const allowedToLockReports = [SERGIC_PARTNER, PRESIDENT_BOARD_MEMBER, COOWNERSHIP_BOARD_MEMBER, CARETAKER];

export const allowedToAccessAlloVoisins =
   ['DIR', 'ESE', 'VSY'].indexOf(SERGIC_OFFER) === -1
      ? []
      : [
           PRESIDENT_BOARD_MEMBER,
           SERGIC_PARTNER,
           DIRECTOR,
           COOWNERSHIP_BOARD_MEMBER,
           COOWNER,
           COOWNER_SECONDARY,
           TENANT,
           CARETAKER,
           EMPLOYEE,
        ];

export const allowedToAccessServices =
   SERGIC_OFFER === 'VQC'
      ? []
      : [
           PRESIDENT_BOARD_MEMBER,
           SERGIC_PARTNER,
           DIRECTOR,
           COOWNERSHIP_BOARD_MEMBER,
           COOWNER,
           COOWNER_SECONDARY,
           TENANT,
           CARETAKER,
           EMPLOYEE,
        ];

export const allowedToAccessCaretakerLodge =
   ['ESE'].indexOf(SERGIC_OFFER) === -1
      ? []
      : [
           PRESIDENT_BOARD_MEMBER,
           SERGIC_PARTNER,
           DIRECTOR,
           COOWNERSHIP_BOARD_MEMBER,
           COOWNER,
           COOWNER_SECONDARY,
           TENANT,
           CARETAKER,
           EMPLOYEE,
        ];

export const allowedToSwitchLanguage =
   SERGIC_OFFER !== 'VQC'
      ? []
      : [
           PRESIDENT_BOARD_MEMBER,
           SERGIC_PARTNER,
           DIRECTOR,
           COOWNERSHIP_BOARD_MEMBER,
           COOWNER,
           COOWNER_SECONDARY,
           TENANT,
           CARETAKER,
           EMPLOYEE,
        ];

export const allowedToSubmitInvoices = SERGIC_OFFER === 'DIR' ? [PRESIDENT_BOARD_MEMBER, COOWNERSHIP_BOARD_MEMBER] : [];

export const allowedToContestInvoices = SERGIC_OFFER === 'DIRR' ? [PRESIDENT_BOARD_MEMBER] : [];

export const allowedToConfirmInvoices = SERGIC_OFFER === 'DIRR' ? [PRESIDENT_BOARD_MEMBER] : [];

export const allowedToAccessPreEtatDate =
   ['DIR', 'ESE', 'VSY', 'ECO'].indexOf(SERGIC_OFFER) > -1
      ? [PRESIDENT_BOARD_MEMBER, COOWNERSHIP_BOARD_MEMBER, COOWNER]
      : [];

export const allowedToAccessBillers =
   ['ESE', 'VSY'].indexOf(SERGIC_OFFER) > -1 ? [PRESIDENT_BOARD_MEMBER, COOWNERSHIP_BOARD_MEMBER, COOWNER] : [];

export const allowedToAccessWorkInvoices = [PRESIDENT_BOARD_MEMBER, SERGIC_PARTNER, DIRECTOR, COOWNERSHIP_BOARD_MEMBER];
